import { FormRenderer } from "../form-render/form-renderer";

export const ContainerInput = (props) => {
  const {
    fields,
    componentContext,
    onFieldChange,
    fieldValues,
    readOnly,
    disabled,
    customClasses,
  } = props;

  return (
    <div className="w-full">
      <div className="-mx-2 flex flex-wrap">
        {fields?.map((item) => (
          <FormRenderer
            key={item?.pathToValue}
            data-testid={item?.pathToValue}
            readOnly={readOnly}
            item={item}
            componentContext={componentContext}
            onFieldChange={onFieldChange}
            fieldValue={fieldValues?.[item?.uniqueField]}
            isSubField
            disabled={disabled}
            customClasses={customClasses}
          />
        ))}
      </div>
    </div>
  );
};
